import { ChallengeStateMap, MoteUnlockState } from "../models";

export interface LoginOptions {
    signInWithPopup?: boolean; // DEPRECATED: We only use signInWithPopup (never redirect) 
    facebook?: boolean;
    google?: boolean;
    apple?: boolean;
    email?: boolean;
    azure?: boolean;
    enableAdminRequest?: boolean;
    enableEmailVerification?: boolean;
    externalLoginFunction?: LoginFunction;
}

// NOTE: If you make changes to this class, make sure to duplicate the change
// to the interface in `@motes-sdk/functions/src/custom-types.d.ts`
export class UserRights {
    uid?: string = "";
    isVerified: boolean = false;
    isAnonymous: boolean = false;
    isAdmin: boolean = false;
    isSuperAdmin: boolean = false;
    authToken?: string = "";
}

import type { FirebaseError } from 'firebase/app';
export class LoginRsp {
    msg: string = "";
    err: string | FirebaseError = "";
    isNewUser: boolean | null = false;
    userRights: UserRights = new UserRights();
}

export enum LoginProvider {
    Anonymous = 'Anonymous',
    Google = 'Google',
    Apple = 'Apple',
    Azure = 'Azure',
    Facebook = 'Facebook',
    DreamHack = 'DreamHack',
    Email = 'Email',
    NotSupported = 'NotSupported'
}

export type LoginFunction = (provider: LoginProvider) => Promise<LoginRsp>;

export class LoginReq {
    msg: string = "";
    requireRights: UserRights = new UserRights();
    externalLoginFunction?: LoginFunction;
}

export interface DreamHackUser {
    id: string,
    first_name: string,
    last_name: string,
    name: string,
    email: string,
    verified_email: string,
    private: boolean,
    clan: string,
    birth_year: number,
    trusted: boolean,
    access: {
        relations: string[],
        permissions: string[],
        roles: string[],
        crew: string[]
    },
    avatar: {
        square64: string
        square160: string
    },
    intercom_hash: string
}

/**
 * Abstract the firebase auth 'UserCredential' type with only needed types to
 * facilitate login with custom providers (non Firebase) like DreamHack
 */
import type { User } from '@angular/fire/auth';
export class LoginUserInfo implements Partial<User> {
    uid: string;
    email: string;
    displayName: any;
    providerData: any[];
    photoURL: string;
    isAnonymous: boolean;
    getIdTokenResult: () => ReturnType<User['getIdTokenResult']>;
}

export interface LoginMigrationData {
    unlockedMotes: MoteUnlockState[];
    challengeStateMap: ChallengeStateMap;
}

/**
 * Abstract the firebase auth 'UserCredential' type with only needed types to
 * facilitate login with custom providers (non Firebase) like DreamHack
*/
import type { UserCredential } from "@angular/fire/auth";
// Substitute the 'user' member of UserCredential with the partial User implementation, LoginUserInfo
type SubstituteUser<T> = { [P in keyof T]: P extends 'user' ? LoginUserInfo : T[P]};

export class LoginCredential implements SubstituteUser<UserCredential> {
    user: LoginUserInfo;
    providerId: string;
    operationType: 'link' | 'reauthenticate' | 'signIn' | null;
}
